module.exports = __webpack_public_path__ + "img/obos_vit.7f4ef5bb.svg";